/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createWebhusetOrderApiFeaturesCartItemMicrosoft365PutResponseFromDiscriminatorValue, serializeWebhusetOrderApiFeaturesCartItemMicrosoft365PutRequest, serializeWebhusetOrderApiFeaturesCartItemMicrosoft365PutResponse, type WebhusetOrderApiFeaturesCartItemMicrosoft365PutRequest, type WebhusetOrderApiFeaturesCartItemMicrosoft365PutResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /cart/{cartId}/microsoft-365/{cartItemId}
 */
export interface WithCartItemItemRequestBuilder extends BaseRequestBuilder<WithCartItemItemRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<WebhusetOrderApiFeaturesCartItemMicrosoft365PutResponse>}
     */
     put(body: WebhusetOrderApiFeaturesCartItemMicrosoft365PutRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<WebhusetOrderApiFeaturesCartItemMicrosoft365PutResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: WebhusetOrderApiFeaturesCartItemMicrosoft365PutRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithCartItemItemRequestBuilderUriTemplate = "{+baseurl}/cart/{cartId}/microsoft-365/{cartItemId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithCartItemItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: WithCartItemItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory:  createWebhusetOrderApiFeaturesCartItemMicrosoft365PutResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeWebhusetOrderApiFeaturesCartItemMicrosoft365PutRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
